'use client';

import React, { useEffect, useState } from 'react';
import fields from './AmenitiesFormConfig.js';
import CardForm from '../../../../components/form/CardForm';
import { Actions } from '../../../../../client/Actions';
import { useParams } from 'react-router-dom';
import { useFetchObject } from '../../../../components/hook/useFetchObject';

const Amenities = () => {
  let { id } = useParams();

  const [count, setCount] = useState();

  const {
    data: house,
    ready: houseReady,
    loadData: loadHouse,
  } = useFetchObject('house/' + id, []);

  if (!houseReady) {
    return <></>;
  }

  return (
    <>
      <CardForm
        title={`Udogodnienia (${count})`}
        fields={fields}
        shadow={false}
        width={12}
        trick={
          'Zaznacz udogodnienia dostępne w tym domku.' +
          'Ich listę i kategorie ustawisz w ustawieniach. Pamiętaj, aby na końcu kliknąć „Zapisz”.'
        }
        formDataChanged={(data) => setCount(data?.amenities?.length)}
        initialData={house}
        api={'house'}
        customSave={(data, postSave) => {
          Actions.post('house/' + id + '/amenities', data.amenities, loadHouse);
        }}
      />
    </>
  );
};

export default Amenities;
